import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { view_seccion } from '../../../environments/seccions'

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.css']
})
export class TablaComponent implements OnInit {
  seccion = ""
  public data_negocio = {
    color_secundario:"#FFFFFF"
  };

  constructor(private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.seccion = view_seccion[params.seccion] || params.seccion;
    })
  }

}
